const { formatText } = require('core/i18n').i18n;


/**
 * Decode into global asset class type.
 * Reference:
 * $BCG$EQUTY - 0
 * $BCG$FXINC - 1
 * $BCG$MNMKT - 1
 * $BCG$ALLOC - 2
 * $BCG$ALTER - 3
 * $BCG$COMMO - 3
 * $BCG$PRPTY - 3
 * $BCG$TAXPR - 3
 **/
const classDecoder = code => (
    {
        '$BCG$EQUTY': 0,
        '$BCG$FXINC': 1,
        '$BCG$MNMKT': 1,
        '$BCG$ALLOC': 2,
        '$BCG$ALTER': 3,
        '$BCG$COMMO': 3,
        '$BCG$PRPTY': 3,
        '$BCG$TAXPR': 3,
    }[code]
);


/**
 * Translate a code into a global asset class
 * Reference:
 * 0 - Equity - Renta variable
 * 1 - Bond - Bonos
 * 2 - Allocation - Capital
 * 3 - Others - Otros
 */
const globalAssetClass = code => (
    [
        formatText('fundsCard-equity'),
        formatText('fundsCard-bond'),
        formatText('fundsCard-allocation'),
    ][classDecoder(code)] || formatText('fundsCard-others')
);


module.exports = globalAssetClass;
